export const glassStyle = {
  base: "bg-[#1A1A2E] border-2 border-[#2D2D4A] shadow-[0_0_0_1px_rgba(124,58,237,0.1),0_4px_24px_-4px_rgba(0,0,0,0.5),0_0_40px_-12px_rgba(124,58,237,0.15)]",
  card: "bg-[#1A1A2E] border-2 border-[#2D2D4A] shadow-[0_0_0_1px_rgba(124,58,237,0.1),0_4px_24px_-4px_rgba(0,0,0,0.5),0_0_40px_-12px_rgba(124,58,237,0.15)] rounded-2xl p-6 relative overflow-hidden",
  input:
    "bg-[#0F0F1A] border-2 border-[#2D2D4A] pl-10 w-full rounded-xl py-3 px-4 text-[#E2E8F0] focus:border-[#7C3AED] focus:outline-none focus:ring-2 focus:ring-[#7C3AED]/20 placeholder-[#94A3B8] transition-all duration-200",
};

export const fadeInAnimation = {
  fadeIn: "transition-all duration-300 ease-out",
  writing: "animate-pulse",
};

export const colors = {
  primary: "#7C3AED",
  primaryLight: "#A78BFA",
  primaryDark: "#5B21B6",
  accent: "#06B6D4",
  surface: "#0F0F1A",
  surfaceLight: "#1A1A2E",
  surfaceElevated: "#252542",
  border: "#2D2D4A",
  borderLight: "#3D3D5C",
  text: "#E2E8F0",
  textMuted: "#94A3B8",
  success: "#10B981",
  warning: "#F59E0B",
  error: "#EF4444",
};
